<script>
import MottoIcon from './motto-icon.vue'

export default {
  components: { MottoIcon },
  props: {
    route: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <RouterLink :class="{ [$style.footerItem]: true, [$style.active]: active }" :to="route">
    <span v-if="active" :class="$style.topBorder" />
    <MottoIcon :name="icon" :icon-color="active ? 'primary' : 'slate'" :class="$style.footerIcon"></MottoIcon>
    <p :class="{ [$style.footerLabel]: true, 'tag-text': active, p2: !active }">{{ label }}</p>
  </RouterLink>
</template>

<style lang="scss" module>
@import '@design';

$icon-size: 21px;

.topBorder {
  position: absolute;
  top: -12px;
  width: 90%;
  height: 4px;
  background: $primary-blue;
  border-radius: 5px;
}

.footerIcon {
  display: block;
  width: auto;
  height: $icon-size;
  margin-bottom: 8px;
  color: $primary-slate !important;
}

.footerLabel {
  display: block;
  width: auto;
  color: $primary-slate !important;
}

.active {
  .footerLabel,
  .footerIcon {
    color: $primary-blue !important;
  }
}

.footerItem {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 249px;
  height: auto;
  margin-top: auto;
  margin-bottom: 14px;
}
</style>
